import api from './api.service';

function save(params) {
  return api.post('/adoptions/upload', params);
}

function store(params) {
  return api.post('/adoptions/store', params);
}

function index(params) {
  return api.get('/adoptions', params);
}

function remove(id, params) {
  return api.delete(`/adoptions/${id}`, params);
}

function reportPropagandistSchool(params) {
  return api.get('/adoptions/reports/propagandist-school', params);
}

function reportSchool(params) {
  return api.get('/adoptions/reports/school', params);
}

function reportEditor(params) {
  return api.get('/adoptions/reports/editor', params);
}

function reportPropagandist(params) {
  return api.get('/adoptions/reports/propagandist', params);
}

function reportPropagandistEditor(params) {
  return api.get('/adoptions/reports/propagandist-editor', params);
}

function reportPropagandistBook(params) {
  return api.get('/adoptions/reports/propagandist-book', params);
}

function reportEditorSchool(params) {
  return api.get('/adoptions/reports/editor-school', params);
}

function reportBookSchool(params) {
  return api.get('/adoptions/reports/book-school', params);
}

function reportSchoolTotal(params) {
  return api.get('/adoptions/reports/school-total', params);
}

export const adoptionsService = {
    index,
    save,
    store,
    remove,
    reportPropagandistSchool,
    reportSchool,
    reportEditor,
    reportPropagandist,
    reportPropagandistEditor,
    reportPropagandistBook,
    reportEditorSchool,
    reportBookSchool,
    reportSchoolTotal,
};
